import request from "@utils/request";

// 防抖
export const DebounceBy = (fn, t) => {
    let delay = t || 500
    let timer
    return function () {
        let args = arguments;
        if (timer) {
            clearTimeout(timer)
        }
        let callNow = !timer
        timer = setTimeout(() => {
            timer = null
        }, delay)
        if (callNow) fn.apply(this, args)
    }
}

/**
 * 用户登录
 * @param data object 用户账号密码
 */
export function login(data) {
    return request.post("/login", data, {login: false});
}

/**
 * facebook用户登录
 * @param data object facebook返回的name，id
 */
export function fb_login(data) {
    return request.post("/fb_login", data, {login: false});
}

/**
 * 用户手机号登录
 * @param data object 用户手机号 也只能
 */
export function loginMobile(data) {
    return request.post("/login/mobile", data, {login: false});
}

/**
 * 用户发送验证码
 * @param data object 用户手机号
 */
export function registerVerify(data) {
    return request.post("/register/verify", data, {login: false});
}

/**
 * 用户手机号注册
 * @param data object 用户手机号 验证码 密码
 */
export function register(data) {
    return request.post("/register", data, {login: false});
}

export function register_new(data) {
    return request.post("/register_new", data, {login: false});
}

export function tp_captcha() {
    return request.get("/tp_captcha",1, {login: false});
}

/**
 * 用户手机号修改密码
 * @param data object 用户手机号 验证码 密码
 */
export function registerReset(data) {
    return request.post("/register/reset", data, {login: false});
}

/**
 * 用老密码修改密码
 * @param data object 老密码 新密码
 */
export function registerResetOld(data) {
    return request.post("/register/reset_by_old", data, {login: false});
}

/*
 * 领取优惠券列表
 * */
export function getCoupon(q) {
    return request.get("/coupons", q, {login: false});
}

/*
 * 点击领取优惠券
 * */
export function getCouponReceive(id) {
    return request.post("/coupon/receive", {couponId: id}, {login: true});
}

/*
 * 批量领取优惠券
 * */
export function couponReceiveBatch(couponId) {
    return request.post("/coupon/receive/batch", {couponId});
}

export function getClubUser() {
    return request.get("/club/user");
}

/*
 * 我的优惠券
 * */
export function getCouponsUser(type) {
    return request.get("/coupons/user/" + type);
}

/*
 * 个人中心
 * */
export function getUser() {
    return request.get("/user");
}

/*
 * 用户信息
 * */
export function getUserInfo() {
    return request.get("/userinfo");
}

/*
 * 个人中心(功能列表)
 * */
export function getMenuUser() {
    return request.get("/menu/user");
}

/*
 * 地址列表
 * */
export function getAddressList(data) {
    return request.get("/address/list", data || {});
}

/*
 * 删除地址
 * */
export function getAddressRemove(id) {
    return request.post("/address/del", {id: id});
}

/*
 * 设置默认地址
 * */
export function getAddressDefaultSet(id) {
    return request.post("/address/default/set", {id: id});
}

/*
 * 获取默认地址
 * */
export function getAddressDefault() {
    return request.get("/address/default");
}

/*
 * 获取单个地址
 * */
export function getAddress(id) {
    return request.get("/address/detail/" + id);
}

/*
 * 修改 添加地址
 * */
export function postAddress(data) {
    return request.post("/address/edit", data);
}

/*
 * 获取收藏产品
 * */
export function getCollectUser(page, limit) {
    return request.get("/collect/user", {page: page, limit: limit});
}

/*
 * 删除收藏产品
 * */
export function getCollectDel(id, category) {
    return request.post("/collect/del", {id: id, category: category});
}

/*
 * 批量收藏产品
 * */
export function postCollectAll(data) {
    return request.post("/collect/all", data);
}

/*
 * 添加收藏产品
 * */
export function getCollectAdd(id, category) {
    return request.post("collect/add", {id: id, category: category});
}

/*
 * 签到配置
 * */
export function getSignConfig() {
    return request.get("/sign/config");
}

/*
 * 签到里的签到列表
 * */
export function getSignList(page, limit) {
    return request.get("/sign/list", {page: page, limit: limit});
}

/*
 * 签到列表
 * */
export function getSignMonth(page, limit) {
    return request.get("/sign/month", {page: page, limit: limit});
}

/*
 * 签到用户信息
 * */
export function postSignUser(sign) {
    return request.post("/sign/user", sign);
}

/*
 * 签到
 * */
export function postSignIntegral(sign) {
    return request.post("/sign/integral", sign);
}

/*
 * 推广数据
 * */
export function getSpreadInfo() {
    return request.get("/commission");
}

/*
 * 推广人列表
 * */
export function getSpreadUser(screen) {
    return request.post("/user/agent_list", screen);
}

/*
 * 推广人订单
 * */
export function getSpreadOrder(where) {
    return request.post("/spread/order", where);
}

/*
 * 资金明细（types|0=全部,1=消费,2=充值,3=返佣,4=提现）
 * */
export function getCommissionInfo(q, types) {
    return request.get("/spread/commission/" + types, q);
}

/*
 * 积分记录
 * */
export function getIntegralList(q) {
    return request.get("/integral/list", q);
}

/*
 * 提现银行
 * */
export function getBank() {
    return request.get("/extract/bank");
}

/*
 * 代理余额 提现申请
 * */
export function postCashInfo(cash) {
    return request.post("/extract/cash", cash);
}

/*
 * 余额提现申请
 * */
export function user_withdraw(data) {
    return request.post("/user/user_withdraw", data);
}

/*export function user_withdraw_new(data) {
    return request.post("/user/user_withdraw_new", data);
}

export function user_withdraw_new1(data) {
    return request.post("/user/user_withdraw_new1", data);
}

export function user_withdraw_new2(data) {
    return request.post("/user/user_withdraw_new2", data);
}*/
/*
 * 余额提现申请 计算手续费
 * */
export function withdraw_fee(data) {
    return request.post("/user/withdraw_fee", data);
}

export function withdraw_fee_usdt(data) {
    return request.post("/user/withdraw_fee_usdt", data);
}
/*
 * 会员中心
 * */
export function getVipInfo() {
    return request.get("/user/level/grade");
}

/*
 * 会员等级任务
 * */
export function getVipTask(id) {
    return request.get("/user/level/task/" + id);
}

/*
 * 资金统计
 * */
export function getBalance() {
    return request.get("/user/balance");
}

/*
 * 活动状态
 * */
export function getActivityStatus() {
    return request.get("/user/activity", {}, {login: false});
}

/*
 * 活动状态
 * */
export function getSpreadImg() {
    return request.get("/spread/banner");
}

/*
 * 用户修改信息
 * */
export function postUserEdit(data) {
    return request.post("/user/edit", data);
}

/*
 * 用户修改信息
 * */
export function getChatRecord(to_uid, data) {
    return request.get("user/service/record/" + to_uid, data);
}

/*
 * 用户修改信息
 * */
export function serviceList() {
    return request.get("user/service/list");
}

/**
 * 用户头像修改
 * @param data
 * @returns {*}
 */
export function setUserAvatar(data) {
    return request.post("/user/set_user_avatar", data);
}

/*
 * 公众号充值
 * */
export function rechargeWechat(data) {
    return request.post("/recharge/wechat", data);
}

/*
 * 退出登录
 * */
export function getLogout() {
    return request.get("/logout");
}

/*
 * 绑定手机号
 * */
export function bindingPhone(data) {
    return request.post("binding", data);
}

/*
 * h5切换公众号登陆
 * */
export function switchH5Login() {
    return request.post("switch_h5", {from: "wechat"});
}

/*
 * 获取推广人排行
 * */
export function getRankList(q) {
    return request.get("rank", q);
}

/*
 * 获取佣金排名
 * */
export function getBrokerageRank(q) {
    return request.get("brokerage_rank", q);
}

/**
 * 检测会员等级
 */
export function setDetection() {
    return request.get("user/level/detection");
}

/**
 * 获取用户须知
 */
export function getUserMessgaes(id) {
    return request.get("article/details/" + id, {}, {login: false});
}

/**
 * 用户的存款信息
 */
export function deposit_info(data) {
    return request.get("/deposit/info", data);
}

/**
 * 存款 - 存入金额
 */
export function deposit_add(data) {
    return request.post("/deposit/add", data);
}

/**
 *存款 - 取出金额
 */
export function deposit_out(data) {
    return request.post("/deposit/out", data);
}

/**
 *存款 - 存取款记录
 */
export function deposit_log(data) {
    return request.get("/deposit/log", data);
}

/**
 *提交客服留言
 */
export function serveReport(data) {
    return request.post("/user/leave_message", data);
}

/**
 *获取客服留言列表
 */
export function serveMsgList(data) {
    return request.get("/user/message_list", data, {login: false});
}

/**
 *获取客服留言详情
 */
export function message_detail(id) {
    return request.get("/user/message_detail/" + id);
}

/**
 *获取客服留言列表未读数量
 */
export function message_answer() {
    return request.get("/user/message_answer");
}

/**
 *获取用户的充值信息
 */
export function recharge_info() {
    return request.get("/recharge/info");
}

export function check_recharge(data) {
    return request.post("/recharge/check_recharge", data);
}

/**
 * 获取绑定的钱包
 * @returns {*}
 */
export function getCashList() {
    return request.get("/cash/list");
}


/**
 *绑定用户的GCash或者JuanCash账号
 */
export function recharge_bind_cash(data) {
    return request.post("/recharge/bind_cash_new", data);
    // return request.post("/recharge/bind_cash", data);
}

/**
 * 修改币安支付昵称
 * @param data
 * @returns {*}
 */
export function setBinanceNickname(data) {
    return request.post("/recharge/set_pay_nickname", data);
}

/**
 *解除绑定用户的GCash或者JuanCash账号
 *
 */
export function recharge_ubind_cash(id, data) {
    return request.post("/recharge/un_bind_cash/" + id, data);
}

/**
 *使用电子账户充值
 *
 */
export function recharge_apply(data) {
    return request.post("/recharge/apply", data);
}

export function recharge_apply_usdt(data) {
    return request.post("/recharge/apply_usdt", data);
}

/**
 *电子钱包充值记录
 */
export function recharge_apply_list(data) {
    return request.get("/recharge/apply_list", data);
}

/**
 *获取电子钱包收款账号
 */
export function recharge_cash_account() {
    return request.get("/cash_account", {page: 1, limit: 10});
}

//代理

/**
 *代理数据汇总
 */
export function agent_achievement() {
    return request.get("/user/agent_achievement");
}

/**
 *用户名下所有代理的信息和业绩
 */
export function agent_list() {
    return request.get("/user/agent_list");
}

/**
 *用户名下所有会员为用户提供的业绩记录
 */
export function agent_commission_log(data) {
    return request.post("/user/agent_commission_log", data);
}

/**
 * 成为代理
 * @param data
 * @returns {*}
 */
export function become_anent(data) {
    return request.post("/user/become_anent", data);
}

/**
 *申请代理
 */
export function promoter_apply(data) {
    return request.post("/user/promoter_apply", data);
}

/**
 *获取申请代理信息
 */
export function promoter_applyInfo() {
    return request.get("/user/promoter");
}

/**
 * 支付链接创建
 */

export function payment_create(data) {
    return request.post("/user/recharge", data);
}

/**
 * 兑换码
 * @param data
 * @returns {*}
 */
export function exchange_code(data) {
    return request.post("/activity/active_code", data);
}

//活动统计数据
export function statistical_data() {
    return request.get("activity/statistical/data");
}

// 大转盘
/**
 * 获取转盘信息
 * @returns {*}
 */
export function getTurntable() {
    return request.get("/activity/turntable/info");
}

/**
 * 开始抽奖
 * @returns {*}
 */
export function startTurntable(data) {
    return request.get("/activity/turntable/start",data);
}

/**
 * 获取谷歌秘钥
 * @returns {*}
 */
export function getGoogleSecret() {
    return request.get("/google/get_google_secret");
}

/**
 * 谷歌验证绑定
 * @param data
 * @returns {*}
 */
export function googleAuthBind(data) {
    return request.post("/google/google_auth_bind", data);
}

/**
 * 谷歌验证修改登录密码
 * @param data
 * @returns {*}
 */
export function googleEditPassword(data) {
    return request.post("/google/google_set_password", data, {login: false});
}

/**
 * 是否设置密码标识
 * @returns {*}
 */
export function getWithdrawPasswordFlag() {
    return request.get("/withdraw/get_withdraw_password_flag");
}

/**
 * 创建提现密码
 * @param data
 * @returns {*}
 */
export function createWithdrawPassword(data) {
    return request.post("/withdraw/create_withdraw_password",data);
}

/**
 * 修改提现密码
 * @param data
 * @returns {*}
 */
export function editWithdrawPassword(data) {
    return request.post("/withdraw/edit_withdraw_password",data);
}

/**
 * 解除绑定
 * @param data
 * @returns {*}
 */
export function unbindWallet(data) {
    return request.post("/withdraw/unbind_wallet",data);
}

/**
 * 重置提现密码
 * @param data
 * @returns {*}
 */
export function resetWithdrawPassword(data) {
    return request.post("/withdraw/reset_withdraw_password",data);
}

/**
 * 获取银行列表
 * @returns {*}
 */
export function get_bank_list() {
    return request.get("/user/get_bank_list");
}

export function get_vn_bank_list() {
    return request.get("/user/get_vnbank_list");
}

export function get_payok_bank_list() {
    return request.get("/user/get_payok_list");
}

export function get_bind_wallet() {
    return request.get("/extract/get_bind_wallet");
}

export function getChannelUseInfo() {
    return request.get("/recharge/channel_use_info");
}